import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaTimesCircle, FaArrowLeft, FaRedo } from 'react-icons/fa';
import { getPaymentResult } from '../../api/paymentService';
import '../../styles/pages/paymentResult.scss';

const PaymentFail = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [paymentData, setPaymentData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPaymentResult = async () => {
            const transactionId = searchParams.get('transactionId');
            const errorParam = searchParams.get('error');

            if (errorParam) {
                setError(decodeURIComponent(errorParam));
                setLoading(false);
                return;
            }

            if (!transactionId) {
                setError('Ödeme işlemi başarısız oldu');
                setLoading(false);
                return;
            }

            try {
                const result = await getPaymentResult(transactionId);

                if (result.data) {
                    setPaymentData(result.data);
                    setError(result.data.message || 'Ödeme işlemi başarısız oldu');
                } else {
                    setError(result.resultMessage || 'Ödeme işlemi başarısız oldu');
                }
            } catch (err) {
                setError('Bir hata oluştu');
            } finally {
                setLoading(false);
            }
        };

        fetchPaymentResult();
    }, [searchParams]);

    if (loading) {
        return (
            <div className="payment-result-container">
                <div className="payment-result-card">
                    <div className="loading-spinner"></div>
                    <p>Ödeme bilgileri yükleniyor...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="payment-result-container">
            <div className="payment-result-card fail">
                <div className="fail-icon">
                    <FaTimesCircle />
                </div>
                <h1>Ödeme Başarısız</h1>
                <p className="fail-message">{error || 'Ödeme işlemi gerçekleştirilemedi'}</p>

                {paymentData?.transactionId && (
                    <div className="transaction-info">
                        <p className="transaction-id">İşlem No: {paymentData.transactionId}</p>
                    </div>
                )}

                <div className="info-box">
                    <p>Lütfen kart bilgilerinizi kontrol ederek tekrar deneyiniz.</p>
                    <p>Sorun devam ederse bankanızla iletişime geçiniz.</p>
                </div>

                <div className="button-group">
                    <button className="retry-button" onClick={() => navigate('/spor-randevu')}>
                        <FaRedo /> Tekrar Dene
                    </button>
                    <button className="back-button" onClick={() => navigate('/')}>
                        <FaArrowLeft /> Ana Sayfaya Dön
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentFail;
